import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import icon from '../../images/fileicon.png'
import 'react-viewer/dist/index.css';
import Viewer from 'react-viewer';
import 'react-viewer/dist/index.css';
const  moment = require('moment');


class LogGallery extends React.Component {

  constructor() {
    super();
    this.state = {
      imagePreview: false,
      image: "",
      slide: null
    }
  }

  openImg = (path, name) => {
    const isImage = this.isImage(name)
    if (isImage) {
      this.setState({image: path, imagePreview: true})
    } else {
      window.open(path, '_blank')
    }
  }

  componentDidMount = () => {
      this.setState({slide: this.props.slide})
  }

  isImage = (fileName) => {
    if (fileName &&
      (fileName.substr(fileName.length - 3) == 'jpg' ||
        fileName.substr(fileName.length - 3) == 'JPG' ||
        fileName.substr(fileName.length - 3) == 'png' ||
        fileName.substr(fileName.length - 3) == 'PNG' ||
        fileName.substr(fileName.length - 4) == 'jpeg' ||
        fileName.substr(fileName.length - 4) == 'JPEG')
    ) {
      return true
    } else {
      return false
    }
  }

  render() {

    const { color, t } = this.props

    let settings = {
      dots: false,
      infinite: false,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      className: "center",
      centerMode: true,
      useCSS: true,
      useTransform: false,
      lazyLoad: true,
      initialSlide: this.props.slide,
      adaptiveHeight: false,

    };

    const styles = {
      box: {
        backgroundColor: 'white',
        boxShadow: '0 2px 8px 0 rgba(0,0,0,0.16)',
        borderRadius: 10,
        padding: 20,
        marginBottom: 10,
        position: 'relative',
        width: '700px',
        margin: '0 auto'
      },
      title: {
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        fontSize: 16,
        marginBottom: 0
      },
      entry: {
        fontFamily: 'Helvetica Neue',
        color: color,
        fontSize: 16,
        marginBottom: 20
      },
      date: {
        width: 'max-content',
        padding: '0px 20px',
        backgroundColor: color,
        borderRadius: 10,
        color: 'white',
        fontFamily: 'Arial Rounded MT Bold',
        fontSize: 12,
        position: 'absolute',
        right: 30,
        top: 30
      },
      fileIcon: {
        width: 40,
        borderRadius: '50%',
        backgroundColor: color,
        border: '1px solid white',
        padding: 7,
        cursor: 'pointer',
        marginRight: 20
      },
      attachment: {
        display: 'flex',
        alignItems: 'top'
      },
      pageNum: {
        width: 'max-content',
        padding: '6px 20px 0px 20px',
        backgroundColor: this.props.color,
        borderRadius: 20,
        color: 'white',
        fontSize: 14,
        margin: '0 auto',
        marginTop: 20
      },
    }
    return (
        <div>
          <Slider 
            {...settings}
          >
            {this.props.data && this.props.data.map( (log, index) => {
              return (
                <div style={{color: 'red'}}>
                  <div style={styles.box}>
                    <h3 style={styles.title}>{t('Class')}</h3>
                    <p style={styles.entry}>{log.className}</p>
                    <h3 style={styles.title}>{t('Title of Work')}</h3>
                    <p style={styles.entry}>{log.title}</p>
                    <h3 style={styles.title}>{t('Skill Category')}</h3>
                    <p style={styles.entry}>{t(log.category)}</p>
                    <h3 style={styles.title}>{t('Skill Cluster')}</h3>
                    <p style={styles.entry}>{t(log.cluster)}</p>
                    <h3 style={styles.title}>{t('Skill Description')}</h3>
                    <p style={styles.entry}>{log.skillCluster ? (log.skillCluster.name || log.skillCluster) : ''}</p>
                    <h3 style={styles.title}>{t('Skill level')}</h3>
                    <p style={styles.entry}>{t(log.skill)}</p>
                    <h3 style={styles.title}>{t('Notes')}</h3>
                    <p style={styles.entry}>{log.notes}</p>
                    <div style={styles.date}>{moment(log.date).format('DD-MM-YY')}</div>
                    {Array.isArray(log.attachments) &&
                    <div>
                      <h3 style={styles.title}>{t('Attachments')}</h3>
                      <div style={styles.attachment}>
                        <div><img style={styles.fileIcon} src={icon} /></div>
                        <div>
                          {log.attachments.map( attachment =>
                            <p onClick={() => this.openImg(attachment.path, attachment.name)} style={styles.entry}>{attachment.name}</p>
                          )}
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                <div style={styles.pageNum}>{index+1} / {this.props.data.length}</div>
                </div>
              )})}
          </Slider>
          <Viewer
            visible={this.state.imagePreview}
            onClose={() => { this.setState({ imagePreview: false }); }}
            images={[{ src: this.state.image, alt: '' }]}
            attribute={false}
            drag={false}
            zoomable={false}
            rotatable={false}
            scalable={false}
            changable={false}
            noNavbar={true}
            noToolbar={true}
            noFooter={true}
          />
        </div>
    );
  }
}

export default LogGallery



// WEBPACK FOOTER //
// ./src/components/LogGallery/index.jsx